import { isNull } from "./validator";

export const GetValue = (data, field, id) => {
    const item = data.find(x => x.id === id);
    return (item) ? item[field] : '';
}

export const CloneObject = (origin) => {
    return Object.assign({}, origin, {});
}

// clon profundo para los entityInit (DTOs JSON-safe): el browserslist de
// producción incluye browsers sin structuredClone (chrome <98, safari/iOS <15.4)
export const cloneEntityInit = (value) =>
    (typeof structuredClone === 'function')
        ? structuredClone(value)
        : JSON.parse(JSON.stringify(value));

export const GetMeses = (emptyOption = false) => {
    let meses = [
        {key: 1, value: '0001 - Enero', code: '0001', cuota: '01', name: 'Enero'},
        {key: 2, value: '0002 - Febrero', code: '0002', cuota: '02', name: 'Febrero'},
        {key: 3, value: '0003 - Marzo', code: '0003', cuota: '03', name: 'Marzo'},
        {key: 4, value: '0004 - Abril', code: '0004', cuota: '04', name: 'Abril'},
        {key: 5, value: '0005 - Mayo', code: '0005', cuota: '05', name: 'Mayo'},
        {key: 6, value: '0006 - Junio', code: '0006', cuota: '06', name: 'Junio'},
        {key: 7, value: '0007 - Julio', code: '0007', cuota: '07', name: 'Julio'},
        {key: 8, value: '0008 - Agosto', code: '0008', cuota: '08', name: 'Agosto'},
        {key: 9, value: '0009 - Septiembre', code: '0009', cuota: '09', name: 'Septiembre'},
        {key: 10, value: '0010 - Octubre', code: '0010', cuota: '10', name: 'Octubre'},
        {key: 11, value: '0011 - Noviembre', code: '0011', cuota: '11', name: 'Noviembre'},
        {key: 12, value: '0012 - Diciembre', code: '0012', cuota: '12', name: 'Diciembre'}
    ];

    if (emptyOption) {
        meses.unshift({key: 0, value: '', code: '', name: ''});
    }
    
    return meses;
}

export const GetFieldMes = (key, field) => {
    const meses = GetMeses();
    const mes = meses.find(f => f.key === key);
    return (mes) ? mes[field] : null;
}

export const OpenObjectURL = (filename, buffer) => {
    const objectUrl = URL.createObjectURL(buffer);
    let a = document.createElement('a');
    a.setAttribute('href', objectUrl);
    a.setAttribute('target', '_blank');
    a.setAttribute("download",filename);
    a.click();
    //window.open(objectUrl);
}

export const GetTipoDatos = (emptyOption = false) => {
    const tipoDatos = [
        {key: 'number', value: 'Número entero'},
        {key: 'decimal', value: 'Número decimal'},
        {key: 'string', value: 'Texto'},
        {key: 'boolean', value: 'Lógico'},
        {key: 'date', value: 'Fecha'},
        {key: 'any', value: 'Indefinido'},
        {key: 'list', value: 'Lista'},
        {key: 'entity', value: 'Entidad'},
        {key: 'function', value: 'Función'},
    ];

    if (emptyOption) {
        tipoDatos.unshift({key: '', value: ''});
    }

    return tipoDatos;
}

export const GetTipoDato = (typeData) => {
    const data = [
        {typeData: 'number', tipoDato: 'Número entero'},
        {typeData: 'decimal', tipoDato: 'Número decimal'},
        {typeData: 'string', tipoDato: 'Texto'},
        {typeData: 'boolean', tipoDato: 'Lógico'},
        {typeData: 'date', tipoDato: 'Fecha'},
        {typeData: 'any', tipoDato: 'Indefinido'},
        {typeData: 'list', tipoDato: 'Lista'},
        {typeData: 'entity', tipoDato: 'Entidad'},
        {typeData: 'function', tipoDato: 'Función'},
    ];

    const item = data.find(x => x.typeData === typeData);

    return (item) ? item.tipoDato : '';
}

export const GetInitDato = (typeData) => {
    const data = [
        {typeData: 'number', value: 0},
        {typeData: 'decimal', value: 0},
        {typeData: 'string', value: ''},
        {typeData: 'boolean', value: false},
        {typeData: 'date', value: null},
        {typeData: 'any', value: ''},
        {typeData: 'list', value: null},
        {typeData: 'entity', value: null},
        {typeData: 'function', value: null},
    ];

    const item = data.find(x => x.typeData === typeData);

    return (item) ? item.value : '';
}

export const GetTitleFromField = (field) => {
    let title = '';
    let partial = '';
    for (let i=0; i < field.length; i++) {
        const char = field[i].toString();
        if (i === 0) {
            partial = char.toUpperCase();
        }
        else if (char === char.toUpperCase()) {
            partial = ' ' + char;
        }
        else {
            partial = char;
        }
        title += partial;
    }

    return title;
} 

export const DistinctArray = (array) => {
    return [...new Set(array)];
}

export const GetArrayNumbers = (toNumber, pad = 0) => {
    return [...Array(toNumber).keys()].map((item, index) => {
        const value = (pad) ? item.toString().padStart(pad,'0'): item.toString();
        return {key: index, value: value, name: value}
    });
}

export const CompareDates = (dateTimeA, dateTimeB) => {
    if (dateTimeA > dateTimeB) return 1;
    else if (dateTimeA < dateTimeB) return -1;
    else return 0;
}

export const ComparePeriodos = (a, b) => {
    const desdeA = isNull(a.fechaDesde) ? -Infinity : a.fechaDesde.getTime();
    const desdeB = isNull(b.fechaDesde) ? -Infinity : b.fechaDesde.getTime();
    if (desdeA !== desdeB) return (desdeA > desdeB) ? 1 : -1;

    const hastaA = isNull(a.fechaHasta) ? Infinity : a.fechaHasta.getTime();
    const hastaB = isNull(b.fechaHasta) ? Infinity : b.fechaHasta.getTime();
    if (hastaA !== hastaB) return (hastaA > hastaB) ? 1 : -1;

    return a.id - b.id;
}

export const GetListaSubTasaValores = (emptyOption = false) => {
    let optionList = [
        {key: 'COEFICIENTE', value: 'Coeficiente'},
        {key: 'COEFICIENTE_CORRIENTE', value: 'Coeficiente corriente'},
        {key: 'COEFICIENTE_ANTERIOR', value: 'Coeficiente anterior'},
        {key: 'COEFICIENTE_ADICIONAL', value: 'Coeficiente adicional'},
        {key: 'IMPORTE', value: 'Importe'},
        {key: 'IMPORTE_MINIMO', value: 'Importe mínimo'},
        {key: 'IMPORTE_MAXIMO', value: 'Importe máximo'},
    ];

    if (emptyOption) {
        optionList.unshift({key: 0, value: ''});
    }

    return optionList;
} 

export const GetDayDifference = (date1, date2) => {
    const timestamp1 = date2;
    const timestamp2 = date1;
    const differenceInMilliseconds = timestamp1 - timestamp2;
    const differenceInDays = differenceInMilliseconds / 1000 / 60 / 60 / 24;
  
    return Math.floor(differenceInDays);
}

export const setFormFocus = (formRef) => {
    if (formRef.current) {
        const enabledFocusableElements = formRef.current.querySelectorAll('input:not([disabled]), select:not([disabled]), textarea:not([disabled]), button');
        if (enabledFocusableElements.length > 0) {
            enabledFocusableElements[0].focus();
        }
    }
}


// const listenersMap = new Map();

// export const addEventListenerAsQueue = (type, newListener, keepQueue) => {
//     let listenersXType = listenersMap.get(type)??[];
//     listenersXType.forEach(listener => {
//         document.removeEventListener(type, listener);
//     });

//     listenersXType = keepQueue ? [...listenersXType, newListener] : [newListener];
//     listenersMap.set(type, listenersXType);

//     listenersXType.reverse().forEach(listener => {
//         document.addEventListener(type, listener);
//     });
// }